import { localStorage } from 'radio-components'
import store from '../store';

localStorage.keepalive.check(
  'radioplayer-popup',
  {
    onDead: () => {
      const state = localStorage.getItem('playing');
      if(state === 'play'){
        localStorage.removeItem('lastChannelState');
        localStorage.removeItem('channel');
        localStorage.setItem('buffering', 'STREAM_STOPPED');
        store.dispatch('radioplayer/activeChannel', null);
        store.dispatch('radioplayer/buffering', 'STREAM_STOPPED');
      }
    }
  }
)

const playerConfigurations = {
  radioplayer: {
    listenUrl: (channelId) => `/player/${channelId}/index.html`,
    watchUrl: (channelId) => `/player/${channelId}/index.html?showVideo=true`,
    allChannelsUrl: () => {
      const lang = window.location.hostname.split('.').pop();
      return `/player/alle_kanalen_${lang}/index.html`
    },
    width: 380,
    height: 685,
  },
  2023: {
    listenUrl: (channelId) => `/luister/${channelId}`,
    watchUrl: (channelId) => `/luister/${channelId}/watch`,
    allChannelsUrl: () => `/luister?autoPlay=false`,
    width: 1280,
    height: 805,
  },
}
const playerConfiguration = playerConfigurations[window.Site.playerVersion] || playerConfigurations.radioplayer;

export const openPlayer = {
  methods: {
    getLastPlayed() {
      return localStorage.getItem('lastChannelState');
    },
    clearLastPlayed() {
      localStorage.setItem('lastChannelState', null);
    },
    playerUrl(channelId) {
      return playerConfiguration.listenUrl(channelId);
    },

    open(url) {
      window.open(url, 'radioplayer', `status=1,width=${playerConfiguration.width},height=${playerConfiguration.height}`);
    },

    openPlayer(channelId, channelIsNotActive, lastChannelPlayed) {
      if (channelIsNotActive && lastChannelPlayed !== channelId) {
        localStorage.setItem('playing', 'play');
        this.open(this.playerUrl(channelId));
      } else {
        const state = localStorage.getItem('playing');
        const buffering = localStorage.getItem('buffering');
        if (state === 'play' && buffering !== 'STREAM_BUFFERING') {
          localStorage.setItem('playing', 'stop');
        } else {
          localStorage.setItem('playing', 'play');
        }
      }
    },
    openChannel(channelId) {
      const channelIsNotActive = localStorage.getItem('channel') !== channelId;
      const lastChannelPlayed = this.getLastPlayed();
      this.openPlayer(channelId, channelIsNotActive, lastChannelPlayed);
    },
    openAllChannels() {
      this.open(playerConfiguration.allChannelsUrl());
    },
    openVideo(channelId) {
      this.open(playerConfiguration.watchUrl(channelId));
    },
  },
};
